import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BindDialogUiComponent, WmsDialogComponent, WmsToggleComponent} from "@wms/components";
import {assignNewPropIndexByType, Config, PrefabConfigurationService, removeUndefinedKeys, _removeProperty, KeyValue, readFileByPath, isNonEmptyString} from "@wms/settings/prefab-config";
import {CommonModule} from "@angular/common";
import {getClonedObject, isDefined, noop, runtimeEventManager, stringStartsWith} from "@wm/core";
import {capitalize, cloneDeep, extend, filter, find, findIndex, findLastIndex, includes, isArray, isEmpty, isEqual, isString, pull, trim} from "lodash-es";
import {forEach} from "lodash";
import {BindVariableService, DialogService, NotificationService, PrefabService} from "@wms/services";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {FormsModule, NgForm} from "@angular/forms";
import {WmsExpressionErrorDirective} from "@wms/app/directives/wms-expression-error/wms-expression-error.directive";
import {FilterPipe} from "@wm/components-base";
import {Subscription} from "rxjs";
import {BaseVariableService, VariableConfigComponent, VariableCrudManagerService} from "@wms/variables";
import {PageWsService} from "@wms/workspace";
import { BasePrefabConfigTab } from '../base-tab-component/base-prefabconfig-tab-component.component';

@Component({
  selector: 'wms-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.less'],
  imports: [
    CommonModule,
    TooltipModule,
    FormsModule,
    WmsToggleComponent,
    WmsExpressionErrorDirective,
    FilterPipe,
    BindDialogUiComponent,
    WmsDialogComponent,
    VariableConfigComponent
  ],
  standalone: true
})
export class PropertiesComponent extends BasePrefabConfigTab implements OnInit {

  PROP_TYPE_UI = 'UIProp';
  PROP_TYPE_SERVER = 'ServerProp';

  propertyTypes: string[];
  properties: any[];
  serverProperties: any[];
  initialServerProperties: any[];
  selectedProperty: any;
  selectedPropertyIndex: number;
  selectedPropertyType: string;
  noPropsAvailable: boolean;
  noServerPropsAvailable: boolean;
  enableServerProps: boolean;
  inValidProperties: { [key: string]: string[] };
  enableUIProps: boolean;
  nameErrMsg: string;
  showUIProps: boolean;
  showServerProps: boolean;
  isDirty: boolean;
  newPropertyIndex: number;
  newServerPropIndex: number;
  bindingTypes: string[];
  widgetTypes: KeyValue[];
  dependsOnTypes: KeyValue[];
  widgets: string[];
  nonSelectableWidgetTypes: string[];
  selectableWidgets: {pageName: string, pageWidget: string}[];
  formValueChangesSubscription: Subscription;
  initialProperties:any
  originalServerPeroperty:any
  @ViewChild('propertiesForm', {static: true}) propertiesForm: NgForm;

  constructor(private prefabService: PrefabService,
              private notificationService: NotificationService, private dialogService: DialogService, private elementRef: ElementRef,
              private bindVariableService: BindVariableService, private pageWsService: PageWsService, private baseVariableService: BaseVariableService, private varManagerService: VariableCrudManagerService) {
    super();
    this.propertyTypes = ['string', 'number', 'boolean', 'date', 'object'];
    this.inValidProperties = {};
    this.inValidProperties[this.PROP_TYPE_UI] = [];
    this.inValidProperties[this.PROP_TYPE_SERVER] = [];
    this.enableUIProps = true;
    this.showUIProps = true;
    this.showServerProps = false;
    this.isDirty = false;
    this.newPropertyIndex = 1;
    this.newServerPropIndex = 1;
    this.bindingTypes = ['', 'in-bound', 'out-bound', 'in-out-bound'];
    this.widgetTypes = [
      {key: 'string', value: 'text'},
      {key: 'radio', value: 'radioset'},
      {key: 'color', value: 'colorpicker'},
      {key: 'checkbox', value: 'checkbox'},
      {key: 'checkboxset', value: 'checkboxset'},
      {key: 'slider', value: 'slider'},
      {key: 'textarea', value: 'textarea'},
      {key: 'date', value: 'date'},
      {key: 'list', value: 'select'}
    ];
    this.dependsOnTypes = [
      {key: 'property', value: this.locale.LABEL_PREFAB_PROPS_DATAOPT_DEPENDSON},
      {key: 'custom', value: this.locale.LABEL_PREFAB_PROPS_DATAOPT_CUSTOM}
    ];
    this.nonSelectableWidgetTypes = ['WM-LAYOUTGRID','WM-GRIDROW', 'WM-GRIDCOLUMN', 'WM-CARD', 'WM-CAROUSEL-CONTENT', 'WM-CARD-CONTENT', 'WM-CARD-FOOTER', 'WM-LISTTEMPLATE', 'WM-COMPOSITE'];
    this.registerDestroyListener.add(runtimeEventManager.on('prepare-properties-save').subscribe(() => this.prepareForSave()));
    this.registerDestroyListener.add(runtimeEventManager.on('save-server-props').subscribe(() => this.saveServerProps()));
    this.registerDestroyListener.add(runtimeEventManager.on('set-prop-validity').subscribe(() => this.setPropValidity()));
    this.registerDestroyListener.add(runtimeEventManager.on('set-property-binding').subscribe((data) => this.setPropertyBinding(data)));
  }

  ngOnInit() {
    this.prepareModelForDisplay(this.prefabConfigService.getConfig());
    this.readServerProps();
    let setInitialValue: boolean = true;
    if (this.initialProperties) {
      setInitialValue = false;
    }
    this.formValueChangesSubscription = this.propertiesForm.form.valueChanges.subscribe(() => {
      if (!this.propertiesForm.form.dirty && setInitialValue) {
        this.initialProperties = this.propertiesForm.form.value;
      }
      if(this.propertiesForm.form.dirty && !isEqual(this.initialProperties,this.propertiesForm.form.value))
        this.prefabConfigService.isDirty['properties'] = true;

    });

    this.resetFormSubscription = this.prefabConfigService.resetForm.subscribe((resetInitialVal) => {
      if (!resetInitialVal) {
        this.propertiesForm.form.reset(this.initialProperties);
        this.prepareModelForDisplay(this.prefabConfigService.getConfig(), true);
        this.showServerProps = false;
        this.enableUIProps = this.properties.length > 0 ? true : false;
        this.noPropsAvailable = this.properties.length > 0 ? false : true
        this.showUIProps = true;
        this.serverProperties = this.originalServerPeroperty ? [...this.originalServerPeroperty] : []
      } else {
        this.initialProperties =  this.propertiesForm.form.value;
      }
    });

  }

  saveServerProps() {
    //if the server properties are not altered do not engage in saving the same records again
    if (isEqual(this.initialServerProperties, this.serverProperties)) {
      return;
    }
    this.prefabService.setServerProps({ 'prefabPropertyList': this.serverProperties}).then(() => {
      this.readServerProps()
    }, (error: any) => {
      this.notificationService.show("error", this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_PREFAB_PROPS_SAVE);
    });
  }

  prepareForSave() {
    let properties: any = {}, propertiesObj: any = getClonedObject(this.properties);
    forEach(propertiesObj, (prop: any, propertyName: string) => {
      if (!prop.name || !prop.type)
        return;

      prop.name = prop.name.toLowerCase().trim();
      prop.type = prop.type.split(',').map(trim).filter(isNonEmptyString).join(',');

      let property: any;
      property             = properties[prop.name] = {};
      property.type        = prop.type;
      property.displayName = prop.displayName;
      property.description = prop.description;
      property.bindable    = prop.bindable;
      property.isList      = prop.isList;

      if (isDefined(prop.value))
        property.value = prop.value;

      if (isDefined(prop.widget)) {
        property.widget = prop.widget;
        if (prop.widget === 'slider') {
          property.min  = prop.sliderMin || 0;
          property.max  = prop.sliderMax || 1;
          property.step = prop.sliderStep || 0.1;
        }
      }
      if (prop.options) {
        property.options = prop.options;

        // If property dependsOn set to 'property', replacing options value with widgetProps key binding
        if(prop.dependsOn === 'property') {
          prop.options      = 'bind:widgetProps.' + prop.options + '.keys';
          property.options  = prop.options;
        }

        // If Property options are not a bindable string
        // Then assuming it as a comma separated value and converting it into array
        if (isString(prop.options) && !stringStartsWith(prop.options, 'bind:')) {
          prop.options = prop.options.split(',');
        }
        // Checking and removing empty strings from options array
        if (isArray(prop.options)) {
          property.options = prop.options.map(trim).filter(isNonEmptyString);
        }
      }
      property.show = prop.show;
      property.showAt = prop.showAt;
      property.disabled = prop.disabled;
    });
    this.prefabConfig.properties = properties;
  }

  readServerProps() {
    this.prefabService.getServerProps().then((serverProps: any) => {
      this.serverProperties         = [];
      this.initialServerProperties  = [];
      if (isArray(serverProps.prefabPropertyList)) {
        this.serverProperties         = serverProps.prefabPropertyList;
        this.initialServerProperties  = JSON.parse(JSON.stringify(serverProps.prefabPropertyList));
      }
      this.originalServerPeroperty  = cloneDeep(this.serverProperties)
      if (isEmpty(this.serverProperties)) {
        this.noServerPropsAvailable = true;
      }
    }, (error: any) => {
      this.notificationService.show("error", this.locale.MESSAGE_ERROR_TITLE, this.locale.MESSAGE_ERROR_PREFAB_PROPS_READ);
    });
  }

  selectFirstProperty() {
    if (!isEmpty(this.properties)) {
      this.selectedProperty = this.properties[0];
      this.selectedPropertyIndex = 0;
      this.selectedPropertyType = 'widget';
      this.focusNameInputField();
    } else {
      this.noPropsAvailable = true;
    }
  }

  focusNameInputField() {
    let nameInput: HTMLElement = this.elementRef.nativeElement.querySelector('input[name=propertyName]');
    if(nameInput) {
      nameInput.focus();
    }
  }

  selectProperty(property: any, type: string, index: number) {
    this.selectedPropertyIndex = index;
    this.selectedPropertyType  = type;
    this.selectedProperty      = property;
    if (type === 'server') {
      this.enableServerProps = true;
    } else if (type === 'widget') {
      this.setUIPropertyValidity(property); //after adding the properties check for the invalid state of the property
      setTimeout(() => {
        this.propertiesForm.controls['propertyName'].markAsPristine();
        this.propertiesForm.controls['propertyName'].markAsUntouched();
        this.focusNameInputField();
      });
    }
  };

  prepareModelForDisplay(config: Config, projectList?:boolean) {
    this.prefabConfig = config;
    let properties: any = config.properties || {};
    properties = Object.keys(properties).map(function (propertyName) {
      let property = properties[propertyName];
      if (!isDefined(property.show)) {
        property.show = true;
      }
      if (!isDefined(property.showAt)) {
        property.showAt = '';
      }
      if (!isDefined(property.disabled)) {
        property.disabled = false;
      }
      if (property.widget === 'slider') {
        property.sliderMin = isDefined(property.min) ? property.min : 0;
        property.sliderMax = isDefined(property.max) ? property.max : 1;
        property.sliderStep = isDefined(property.step) ? property.step : 0.1;
      }
      property.dependsOn = 'custom';
      if (isDefined(property.options) && property.options.indexOf('bind:widgetProps.') > -1) {
        property.dependsOn = 'property';
        property.options = property.options.replace('bind:widgetProps.', '').replace('.keys', '');
      }

      return extend({}, {name: property.name || property.tempName || propertyName}, property);
    });
    this.properties = removeUndefinedKeys(properties);
    this.selectFirstProperty();
    this.widgets = [];
    this.selectableWidgets = [];
    if(!projectList){
    this.projectService.getPagesList().then((pages: any) => {
      forEach(pages, (page: any) => {
        if (page.type !== 'TEMPLATE') {
          readFileByPath('pages/' + page.name + '/' + page.name + '.html', (content: any) => {
            $(content).find('[name]').each((i, t) => {
              // @ts-ignore
              let $t = $(t), widgetName: string = $t.attr('name');
              this.widgets.push(widgetName);
              if (findIndex(this.nonSelectableWidgetTypes, function(v) { return v === $t.prop('tagName')}) < 0) {
                this.selectableWidgets.push({
                  pageName: page.name,
                  pageWidget: widgetName
                });
              }
            });
          }, () => noop());
        }
      });
    })
  }
  }

  checkInvalidProperties() {
    forEach(this.inValidProperties[this.PROP_TYPE_UI], (propName: string) => {
      if (filter(this.properties, {name: propName}).length <= 1) {
        pull(this.inValidProperties[this.PROP_TYPE_UI], propName);
      }
    });
    forEach(this.inValidProperties[this.PROP_TYPE_SERVER], (propName: string) => {
      if (filter(this.properties, {name: propName}).length <= 1) {
        pull(this.inValidProperties[this.PROP_TYPE_SERVER], propName);
      }
    });
  }

  setPropValidity(propertyType?: string, propertyName?: string, isValid?: boolean) {
    if (propertyName && propertyType) {
      if (!isValid) {
        this.inValidProperties[propertyType].push(propertyName);
      } else if (includes(this.inValidProperties[propertyType], propertyName)) {
        pull(this.inValidProperties[propertyType], propertyName);
        this.prefabConfigService.hideErrorMsg$.next();
      }
    }
    this.checkInvalidProperties();
    this.prefabConfigService.isInvalid['properties'] = !isEmpty(this.inValidProperties[this.PROP_TYPE_UI]) || !isEmpty(this.inValidProperties[this.PROP_TYPE_UI]) || (this.selectedProperty && this.selectedProperty.invalid) || this.propertiesForm.form.invalid;
  }
  //check if the selected property is invalid
  setUIPropertyValidity(property: any) {
    property.invalid = property.nameInvalid || property.typeInvalid || !property.name || !property.type || property.descriptionInvalid || !property.description;
    this.setPropValidity(this.PROP_TYPE_UI, property.name, !property.invalid);
  }

  removeProperty(property: any) {
    _removeProperty(this.properties, property);
    this.prefabConfig.properties = this.properties;
    this.setDirty();
    if (isEmpty(this.properties)) {
      this.enableUIProps    = false;
      this.noPropsAvailable = true;
    }
    this.selectFirstProperty();
    /*re-validate properties after the property is removed*/
    forEach(this.properties, (property: any) => this.validateUIPropertyName(property));
  }

  removeServerProperty(property: any) {
    _removeProperty(this.serverProperties, property);
    if (isEmpty(this.serverProperties)) {
      this.noServerPropsAvailable = true;
      this.enableServerProps = false;
    }
    this.selectFirstProperty();
  };

  validateUIPropertyName(property: any) {
    if (property.name && this.checkUIPropertyExists(property)) {
      property.nameInvalid = true;
      this.nameErrMsg = this.locale.MESSAGE_PREFAB_ERROR_DUPLICATE_PROPERTY_NAME;
    } else {
      if (!property.name) {
        property.nameInvalid = true;
        this.nameErrMsg = this.locale.MESSAGE_PREFAB_ERROR_PATTERN_PROPERTY_NAME;
      } else {
        property.nameInvalid = false;
        property.displayName = property.displayName || capitalize(property.name);
      }
    }
    this.setUIPropertyValidity(property);
  }

  checkUIPropertyExists(property: any) {
    let nameExists = false;
    // @ts-ignore
    forEach(this.properties, (prop: any) => {
      if(!isEqual(prop, property) && prop.name === property.name) {
        nameExists = true;
        return false;
      }
    });
    return nameExists;
  }

  setDirty() {
    this.prefabConfigService.isDirty['properties'] = true;
  }

  addProperty(event: any) {
    event.stopPropagation();
    event.preventDefault();
    assignNewPropIndexByType('ui-property', this.newPropertyIndex, 'Property ', this.properties);
    this.enableUIProps   = true;
    this.showUIProps     = true;
    this.showServerProps = false;
    this.noPropsAvailable = false;
    this.properties.push({
      'tempName' : 'Property ' + this.newPropertyIndex,
      'show'     : true,
      'disabled' : false,
      'type'     : 'string',
      'widget'   : 'string',
      'bindable' : 'in-bound',
      'dependsOn': 'custom'
    });
    this.prefabConfig.properties = this.properties;
    this.setDirty(); //set dirty when the property is added
    this.selectProperty(this.properties[this.properties.length - 1], 'widget', this.properties.length - 1);
    this.newPropertyIndex++;
  }

  addServerProperty(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.enableServerProps      = true;
    this.showUIProps            = false;
    this.showServerProps        = true;
    this.noServerPropsAvailable = false;
    while(!!find(this.serverProperties, {key: 'property' + this.newServerPropIndex})) {
      this.newServerPropIndex++;
    }
    this.serverProperties.push({'key': 'property' + this.newServerPropIndex, 'defaultValue': ''});

    let serverPropsLength = this.serverProperties.length;

    this.selectProperty(this.serverProperties[serverPropsLength - 1], 'server', serverPropsLength - 1);
    this.setDirty(); //set dirty when new property is added
    this.newServerPropIndex++;
  };

  isInvalidServerProperty(property: any) {
    let existingProperty = find(this.serverProperties, {key: property.key});
    if (existingProperty) {
      if (findIndex(this.serverProperties, {key: property.key}) !== findLastIndex(this.serverProperties, {key: property.key})) {
        this.setPropValidity(this.PROP_TYPE_SERVER, property.name, false);
        return true;
      }
    }
    this.setPropValidity(this.PROP_TYPE_SERVER, property.name, true);
    return false;
  }

  validateFields(type: string) {
    switch (type) {
      case 'name':
        this.validateUIPropertyName(this.selectedProperty);
        break;
      case 'type':
        this.selectedProperty.typeInvalid = !this.selectedProperty.type;
        this.setUIPropertyValidity(this.selectedProperty);
        break;
      case 'description':
        this.selectedProperty.descriptionInvalid = !this.selectedProperty.description;
        this.setUIPropertyValidity(this.selectedProperty);
        break;
      case 'serverproperty':
        this.selectedProperty.invalid = !this.selectedProperty.key || this.isInvalidServerProperty(this.selectedProperty);
        break;
    }
  }

  clearBoundValue(event: any, selectedProperty: any, key: string, defVal: any) {
    event.stopPropagation();
    selectedProperty[key] = defVal;
    this.setDirty();
  };

  setPropertyBinding(data: any) {
      this.selectedProperty[data.key] = data.boundVariable;
  }

  showVariableDialog(property: any) {
    if (property?.startsWith("bind:Variables.")) {
      let boundEntity = property.replace("bind:Variables.", ''),
        variableName = boundEntity.slice(0, boundEntity.indexOf('.'));
      this.baseVariableService.reloadVariables().then(() => {
        forEach((this.baseVariableService.variableCollection), (collection: any) => {
          forEach(collection, (variable: any) => {
            if (variable.name === variableName) {
              this.baseVariableService.selectedVariableView = 'Variables';
              this.varManagerService.initVariablePropertyList();
              this.varManagerService.getTypesOfSelectedVariables(variable.category, variable);
              this.openDialogWithId('variableModal');
            }
          })
        });
      });
    }
  }

  handlePropertyBinding(property: any, key: string) {
    this.setDirty();
    let dialogParams = {
      bindMode    : 'prefab-props',
      key         : key,
      showPageSelection: true,
      boundEntity : property[key],
      activePageName: this.pageWsService.activePageName,
      activeProperty: {
        propertyOwnerName : 'Prefab-Property',
        propertyDetails   : property,
        name              : property.name
      },
      propertyBindCallback: function (boundVariable: any){
        property[key] = boundVariable;
      }
    }
    this.openDialogWithId('BindVariable');
    this.bindVariableService.dialogParams = dialogParams
  }
  onBindableValChange() {
    if(this.selectedProperty.bindable === 'out-bound') {
      this.selectedProperty.show = false;
      this.selectedProperty.disabled = true;
    } else {
      this.selectedProperty.show = true;
      this.selectedProperty.disabled = false;
    }
  }

  onChangeWidgetType(property: any) {
    if (property.widget === 'slider') {
      property.sliderMin  = 0;
      property.sliderMax  = 1;
      property.sliderStep = 0.1;
    }
  }

  // @ts-ignore
  enableOptions(property: any) {
    let widget = property.widget, type = property.type;
    if (isDefined(widget)) {
      return widget === 'list' || widget === 'checkboxset' || widget === 'radio';
    }
    if (isDefined(property.type)) {
      return type === 'list' || property.isList === true;
    }
  }

  excludeSelectedProperty() {
    let filteredProps: any = getClonedObject(this.properties);
    filteredProps = filteredProps.filter((prop: any) => { return prop.name !== this.selectedProperty.name && ['in-bound', 'in-out-bound'].indexOf(prop.bindable) > -1;});
    return filteredProps;
  }

  isBindExpression(property: any) {
    return typeof property === 'string' && property.indexOf('bind:') > -1;
  }

  showAccordions(type: string) {
    switch (type) {
      case 'ui': this.showUIProps     = true;
                 this.showServerProps = false;
                 break;
      case 'server': this.showUIProps     = false;
                     this.showServerProps = true;
                     break;
    }
  }

  override ngOnDestroy() {
    this.formValueChangesSubscription.unsubscribe();
  }

  onToggleChange(property: string, $event: boolean) {
    this.selectedProperty[property] = $event;
  }

  openDialogWithId(id: string) {
    this.dialogService.open(id);
  }

  closeDialogWithId(id: string) {
    this.dialogService.close(id);
  }
}
